import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosStatic
} from "axios";
import router from "@/router";
import {message} from "ant-design-vue";
import {authorities} from "@/request/config";
import state from "@/store/state";
const Message = message;
// const toLogin = () => {
//   router.replace({
//     name: "Login"
//   });
// };
//上次提示信息时间
let tsTime = 0;
/**
 * 请求失败错误信息统一处理
 */
const errorHandle = (status, msg) => {
  switch (status) {
    case 400:
      // Message.error(msg || "请求错误");
      break;
    case 401: {
      // const getStorage: any = localStorage.getItem("tsTime");
      // tsTime = getStorage ? JSON.parse(getStorage).tsTime : 0;
      // if (tsTime == 0 || new Date().getTime() - tsTime > 10000) {
      //   tsTime = new Date().getTime();
      //   localStorage.setItem("tsTime", JSON.stringify({"tsTime": tsTime}));
      //   let userInfoStr = localStorage.getItem("userInfo");
      //   userInfoStr = userInfoStr == null ? "" : userInfoStr;
      //   const userInfo = JSON.parse(userInfoStr);
      //   if (userInfo) {
      //     if (userInfo.orgType == 4 || userInfo.orgType == 5){
      //       alert("登录超时，请从教师资格管理信息系统重新跳转。");
      //       window.opener = null;
      //       window.close();
      //     }else{
      //       alert("登录超时，请重新登录。");
      //       // Message.error(msg || "请重新登录");
      //       toLogin();
      //     }
      //   }
      // }
      break;
    }
    default:
  }
};
const instance = axios.create();
instance.defaults.baseURL = "/";
// instance.defaults.baseURL = "/api";

instance.defaults.headers.post["Content-Type"] = "application/json; application/octet-stream";

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    sessionStorage.setItem("delayed", "1");
    // const storageToken = JSON.parse(sessionStorage.getItem("vuex") as any);
    const token="111111";
    // const token = state.token
    //     ? state.token
    //     : storageToken
    //         ? storageToken.token
    //         : "";
    config.headers = {
      Authorization: token,
      token
    };
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截
instance.interceptors.response.use(
  (res) => {
    // const {code, message} = res.data;
    // if (code) {
    //   // if ((res as any).config.url.indexOf("/rest/sso/query") != 0) {
    //   //   errorHandle(code, message);
    //   //   if (code == 401) {
    //   //     window.location.href = '/'
    //   //   }
    //   // }
    // }
    return res;
  },
  error => Promise.reject(error)
);

// export const request = (key: string, data = {},obj:any={}) => {
//     const getMethod = authorities[key].method;
//     let getUrl:any = authorities[key].url;
//
//     if (obj.path) {
//         for (const item of obj.path) {
//             const rplaceArr = Object.keys(item);
//             rplaceArr.forEach(el => {
//                 getUrl = getUrl.replace(`[${el}]`, item[el]);
//             })
//         }
//     }
//     const params = getMethod === "get" ? data : {};
//     const datas = getMethod === "post" ? data : {};
//
//     return instance({
//         method: getMethod,
//         url: getUrl,
//         params: params,
//         data: datas
//     });
// };


export const request = (obj,data = {},param = {}) => {
  const getMethod =obj.method;
  const getUrl = obj.url;
  let params = getMethod === "get" ? data : param;
  let datas= getMethod === "post"||"put" ? data : {};

  return instance({
    method: getMethod,
    url: getUrl,
    params: params,
    data: datas
  });
};



export const download = (key, data = {}, param = {}) => {
  const getMethod = authorities[key].method;
  const getUrl = authorities[key].url;
  const params = getMethod === "get" ? data : param;
  const datas = getMethod === "post" ? data : {};
  return instance({
    method: getMethod,
    url: getUrl,
    params: params,
    data: datas,
    responseType: 'blob'
  });
};




export const requestPath = (
  key,
  data = {},
  param = {},
  pathParam = {}
) => {
  const getMethod = authorities[key].method;
  const getUrl = authorities[key].url + (pathParam ? pathParam : "");

  const params = getMethod === "get" ? data : param;
  const datas = getMethod === "post" ? data : {};
  return instance({
    method: getMethod,
    url: getUrl,
    params: params,
    data: datas
  });
};

// export const requestAll = (values: Function[]) => {
//   const instanceAll: AxiosStatic = axios;
//   return instanceAll.all(values);
// };





// WEBPACK FOOTER //
// ./src/request/index.js